import { CommonModule, Location } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Editor } from 'ngx-editor';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../core/services/auth.service';
import { FileService } from '../../../../core/services/file.service';
import { ProfessorService } from '../../../../core/services/professor.service';
import { SchoolService } from '../../../../core/services/school.service';
import { UserSettingService } from '../../../../core/services/user-setting.service';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppUserSetting } from '../../../../core/utils/app-user-setting';
import { ConfigService } from '../../../../core/utils/config-service';
import { GlobalName } from '../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../components/loading/loading.component';
import { HeaderComponent } from '../../../admin/layout/includes/header/header.component';

@Component({
    selector: 'app-professor-account',
    templateUrl: './professor-account.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule],
    styleUrls: ['./professor-account.component.css']
})
export class ProfessorAccountComponent {
  fileSrc:any="assets/avatar.jpg"
  loading=false
  fileInput:any
  data:any
  tag="professors-account"
  userSetting:any=AppUserSetting
  setMaj=false

  constructor(
    private spinnerService:NgxSpinnerService,
    private fileService:FileService,
    private professorService:ProfessorService,
    private usService:UserSettingService,
    private authService:AuthService,
    private toastrService:ToastrService,
    private router: Router,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }

  ngOnInit(): void {
      this.getOne()

  }

getOne(){
  this.authService.me().subscribe((res:any)=>{
   this.data=res.user
   this.userSetting.need_tfa=this.data.user_setting?.need_tfa
   this.userSetting.need_notification=this.data.user_setting?.need_notification
   this.userSetting.mark_alert=this.data.user_setting?.mark_alert
   this.userSetting.agenda_alert=this.data.user_setting?.agenda_alert
   this.userSetting.useful_alert=this.data.user_setting?.useful_alert
   this.userSetting.reminder_alert=this.data.user_setting?.reminder_alert
   this.userSetting.timetable_alert=this.data.user_setting?.timetable_alert
   if(this.data.photo!=null) this.fileSrc=`${ConfigService.toFile('storage/avatars')}/${this.data.photo}`

   if (this.setMaj) {
    this.lsService.set(GlobalName.userName,res.user);
    window.location.reload()
   }
  },
  (err:any)=>{
    AppErrorShow.showError("Mon compte",err)

  })

}
  getFile(disk:any,folder:any,filename:any){
    this.spinnerService.show()
    //this.pdfViewLoader=true
    this.fileService.get({
      folder:folder,
      disk:disk,
      filename:filename
    }).subscribe((res:any)=>{
      this.spinnerService.hide()
     // this.pdfViewLoader=false
      this.fileSrc=res[0]
     // this.offcanvasService.open(this.contentPDF,{  panelClass: 'details-panel', position: 'end'  });

    },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Mon compte",err)

    })
  }



  setData(value:any){
    let formData= new FormData()

    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        const element = value[key];
          formData.append(key,element)
      }
    }

    if (this.fileInput!=undefined) {
      formData.append("photo",this.fileInput)
    }
    this.professorService.updateAccount(this.data.id,formData).subscribe((res:any)=>{
      this.toastrService.success(res.message)
      this.loading=false
      this.setMaj=true
      this.getOne()
    },
    (err:any)=>{
      this.loading=false
      AppErrorShow.showError("Mon compte",err)

    })
  }

  readFile(){
    var reader = new FileReader();

    reader.readAsDataURL(this.fileInput); // read file as data url

    reader.onload = (event) => { // called once readAsDataURL is completed
      this.fileSrc = event.target?.result;
    }
  }

  loadImg(event:any){
    if(event.target.files.length!=0){
      this.fileInput=event.target.files[0]
      this.readFile()
    }
  }

  changePassword(value:any){
    this.loading=true
    this.authService.changePassword(value).subscribe((res:any)=>{
      this.loading=false
      this.toastrService.success(res.message, 'Mon compte');
      this.logout()
    },
    (err:any)=>{
      this.loading=false
      this.toastrService.error('Changement de mot de passe échouée', 'Mon compte');

    });
  }
  setSetting(){
    console.log(this.userSetting)
    setTimeout(() => {
      this.loading=true
      this.usService.store(this.userSetting).subscribe((res:any)=>{
        this.loading=false
        this.toastrService.success(res.message, 'Paramètre utilisateur connecté');
        this.getOne()
      },
      (err:any)=>{
        this.loading=false
        this.toastrService.error(err.error.message, 'Paramètre utilisateur connecté');
  
      });
    }, 1000);
  
  }

  logout(){
    this.authService.logout().subscribe((res:any)=>{
      this.lsService.remove(GlobalName.tokenName)
      this.lsService.remove(GlobalName.refreshTokenName)
      this.lsService.remove(GlobalName.expireIn)
      this.router.navigate(['/admin/login'])
      this.toastrService.success('Déconnexion réussie', 'Connexion');
    }),
    ((err:any)=>{
      console.log(err)
      this.toastrService.success('Déconnexion échouée', 'Connexion');

    });
  }
}
